const TemplatePickerModal = ({ isOpen, templates, onPick, onClose }) => {
  if (!isOpen) return null;

  return (
    <div
      className="pcm-modal-overlay"
      data-testid="template-picker-overlay"
      onClick={onClose}
    >
      <div
        className="pcm-modal pcm-template-modal"
        data-testid="template-picker-modal"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="pcm-modal-header">
          <h2 className="pcm-modal-title">Choose a Template</h2>
          <button
            type="button"
            className="pcm-modal-close"
            onClick={onClose}
            data-testid="template-picker-close"
          >
            ✕
          </button>
        </div>
        <div className="pcm-template-grid" data-testid="template-grid">
          {templates.map((template) => (
            <button
              key={template.id}
              type="button"
              className="pcm-template-card"
              onClick={() => onPick(template.id)}
              data-testid={`template-${template.id}`}
            >
              <span className="pcm-template-label">{template.label}</span>
              <span className="pcm-template-desc">{template.description}</span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TemplatePickerModal;
